import { render, staticRenderFns } from "./FourthPage.vue?vue&type=template&id=6669a51d&"
import script from "./FourthPage.vue?vue&type=script&lang=js&"
export * from "./FourthPage.vue?vue&type=script&lang=js&"
import style0 from "./FourthPage.vue?vue&type=style&index=0&id=6669a51d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports